import { STATIC_FILES_CDN_URL } from 'constant'

export const resourcePath = '../listing/'

export const locationPinIcon = `${STATIC_FILES_CDN_URL}location-pin.svg`

export const EVENT_NAME = {
  SUCCESS: 'ON_MAP_SUCCESS',
  LOADING: 'ON_MAP_LOADING',
  FAILURE: 'ON_MAP_FAILURE',
}
